const TagItem = ({ tag, className }: { tag: string; className?: string }) => {
  return (
    <div className={`bg-tag text-tag-text px-3 py-1 rounded-full text-sm font-medium w-fit ${className}`}>{tag}</div>
  )
}

export default TagItem
